"use client";

import { useAuth } from "../context/AuthContext";

/**
 * Hook personalizado para obtener el accountId del usuario autenticado
 * @returns El accountId del usuario o null si no está autenticado
 */
export function useAccountId(): string | any {
  const { accountId, getAccountId } = useAuth();

  // Primero intentamos obtener el accountId del estado
  if (accountId) {
    return accountId;
  }

  // Si no está en el estado, lo obtenemos del localStorage
  return getAccountId();
}
